import { render, staticRenderFns } from "./NewSignupData.vue?vue&type=template&id=45fb5781"
import script from "./NewSignupData.vue?vue&type=script&lang=js"
export * from "./NewSignupData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports